import React from 'react';
import cn from 'clsx';
import { notification } from 'antd';
import { ReactComponent as CommonFileSvg } from 'assets/icons/files/Common.svg';
import { ReactComponent as FolderSvg } from 'assets/icons/files/Folder.svg';
import { ReactComponent as ReviewAcceptSvg } from 'assets/icons/New/ReviewAccept.svg';
import { ReactComponent as ReviewRejectSvg } from 'assets/icons/New/ReviewReject.svg';
import { ReactComponent as CheckSvg } from 'assets/icons/New/check-icon.svg';
import { ReactComponent as InfoFillSvg } from 'assets/icons/New/InfoFill.svg';
import { ReactComponent as ReminderSvg } from 'assets/icons/New/Reminder.svg';
import { ATooltip } from 'components/Antd';
import ColumnActions from 'components/Antd/Table/ColumnActions';
import { getDateWithFormat, getMomentDate } from 'util/date';
import { renderSource } from 'views/DocumentManagement/components/Jobs/constants';
import { formatBytes } from 'util/file';
import T from 'i18n-react';
import classes from './Jobs.module.scss';
import CellFactory from 'components/Molecules/Table/Cells/CellFactory';
// import { useFunctionBarActions } from 'views/DocumentManagement/useFunctionBarActions';

const renderDocumentName = (val, obj) => {
  const fileIsClickable = !obj?.isFolder && !!obj?.previewUrl && !!val;
  return (
    <span>
      {obj?.isFolder ? <FolderSvg /> : <CommonFileSvg />}
      <span
        className={cn({
          [classes.fileIsClickable]: fileIsClickable,
        })}
        onClick={() => {
          if (fileIsClickable) {
            const win = window.open(obj.previewUrl, '_blank');
            win.focus();
          }
        }}>
        {val || '/'}
      </span>
    </span>
  );
};
const renderType = (val, obj) => {
  if (obj?.isFolder) return '';
  return val?.name || '/';
};
const renderSize = (val, obj) => {
  if (obj?.isFolder) return '';
  return formatBytes(Number(val || 0));
};
const renderDate = (isReminder, onReview, onUpdateDocument) => (val, obj) => {
  if (obj?.isFolder) return '';
  const today = getMomentDate('', true);
  const tMomentVal = getMomentDate(val);
  const isRed = !isReminder && !!tMomentVal && tMomentVal.isSameOrBefore(today);
  const displayValue = getDateWithFormat(val, 'DD MMM YYYY') || '/';
  const showReminder = !!obj?.reminderType;
  const isReminderExpiry = obj?.reminderType === 'onExpiryDate';
  const isReminderReview = obj?.reminderType === 'onReviewDate';
  const isSent = (isReminderExpiry && !obj?.expiryDate) || (isReminderReview && !obj?.reviewDate);
  const reviewStatus = obj?.isVerified;
  const dropdownItems = [
    {
      key: '1',
      label: (
        <span className={classes.actionReviewItem}>
          {/* <CheckSvg /> */}
          <span>Review</span>
        </span>
      ),
      onClick: () => {
        onReview(obj);
      },
    },
  ];
  // const qmasDocumentRef = React.createRef();
  // const closeModalRef = React.createRef(null);
  // const [readonly, setReadonly] = React.useState(true);

  return (
    <span
      className={cn({
        [classes.red]: isRed,
      })}>
      <span>{displayValue}</span>
      {!(obj?.isFolder && isReminder) && (
        <span className={classes.reminderWrapper}>
          {isReminder && (
            <>
              {showReminder ? (
                <ATooltip
                  dark
                  placement="bottomRight"
                  overlayClassName={classes.tooltipOverlay}
                  title={
                    <>
                      Email Reminder {isSent ? 'Sent ' : ''}on{' '}
                      {getDateWithFormat(obj.reminderDate, 'DD MMM YYYY') || '/'}
                      <br />
                      Note: {obj?.note || '/'}
                    </>
                  }>
                  <span
                    className={cn(classes.reminderIcon, {
                      [classes.isSent]: isSent,
                    })}>
                    <ReminderSvg />
                  </span>
                </ATooltip>
              ) : (
                <span></span>
              )}
            </>
          )}
          {isReminder && (
            <>
              <ATooltip
                dark
                placement="bottomRight"
                overlayClassName={classes.tooltipOverlay}
                title={
                  !!reviewStatus && (
                    <span className={classes.reviewStatusContent}>
                      <span>
                        {reviewStatus === 'accepted'
                          ? 'Accepted'
                          : reviewStatus === 'rejected'
                          ? 'Rejected'
                          : 'Reviewed'}{' '}
                        by{' '}
                        {[obj.verifiedByUser?.firstName, obj.verifiedByUser?.lastName]
                          .filter((v) => !!v)
                          .join(' ')}
                      </span>
                      <span>{obj.verifyNotes}</span>
                      <span>{getDateWithFormat(obj.verifiedAt, 'DD MMM YYYY, HH:mm')}</span>
                    </span>
                  )
                }>
                <span>
                  {reviewStatus === 'accepted' ? (
                    <ReviewAcceptSvg />
                  ) : reviewStatus === 'rejected' ? (
                    <ReviewRejectSvg />
                  ) : reviewStatus === 'notApplicable' ? (
                    'N/A'
                  ) : (
                    ''
                  )}
                </span>
              </ATooltip>
              {CellFactory('QMASDocumentModalCell', {
                documents: [{ ...obj, documentListId: obj.id }],
                onSubmit: (values, form, stateReadonly, cb) => {
                  if (!stateReadonly) {
                    onUpdateDocument(obj, values, form, cb);
                  }
                },
                triggerElement: (
                  <ATooltip
                    dark
                    placement="bottomRight"
                    overlayClassName={classes.tooltipOverlay}
                    title={<>View Document Detail</>}>
                    <span>
                      <InfoFillSvg />
                    </span>
                  </ATooltip>
                ),
              })}

              <ColumnActions
                items={dropdownItems}
                dropdownOverlay={classes.actionDropdown}
                className={classes.columnAction}
              />
            </>
          )}
        </span>
      )}
    </span>
  );
};

export const getColumns = ({ onReview, onUpdateDocument }) => {
  const JobColDefs = [
    {
      title: T.translate('documentManagement.table.name'),
      dataIndex: 'name',
      width: '20%',
      render: renderDocumentName,
      className: classes.nameColumn,
      width: 450,
    },
    {
      title: T.translate('documentManagement.table.type'),
      dataIndex: 'type',
      width: '10%',
      render: renderType,
    },
    {
      title: T.translate('documentManagement.table.source'),
      dataIndex: 'source',
      width: '10%',
      render: renderSource,
      className: classes.sourceColumn,
    },
    {
      title: T.translate('documentManagement.table.reviewDate'),
      dataIndex: 'reviewDate',
      width: '10%',
      render: renderDate(),
    },
    {
      title: T.translate('documentManagement.table.expiryDate'),
      dataIndex: 'expiryDate',
      render: renderDate(),
    },
    {
      title: T.translate('documentManagement.table.size'),
      dataIndex: 'size',
      render: renderSize,
    },
    {
      title: T.translate('documentManagement.table.uploadedDate'),
      dataIndex: 'uploadedDate',
      render: renderDate(true, onReview, onUpdateDocument),
      className: classes.uploadedDateColumn,
    },
  ];
  return JobColDefs;
};
export const OTHER_FIELDS = [
  'issueDate',
  'reminderDate',
  'reviewDate',
  'expiryDate',
  'reminderType',
  'source',
  'note',
  'suppliers',
  'products',
  'factories',
];
